import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ShieldCheck = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      stroke={stroke || 'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.5 7.5L7.5 9.5L11 6M8 2L2.5 4V7.5C2.5 13.5 8 14 8 14C8 14 13.5 13.5 13.5 7.5V4L8 2Z" />
    </svg>
  ),
)
ShieldCheck.displayName = 'ShieldCheck'

export default ShieldCheck
